import { LeadStatus, OutreachResult, LeadAutomationStatus } from '../types';

// Lead status helpers
export const getLeadStatusColor = (status: LeadAutomationStatus | LeadStatus): string => {
  switch (status) {
    case LeadAutomationStatus.NEW:
    case LeadStatus.NEW:
      return 'bg-gray-100 text-gray-800';
    case LeadAutomationStatus.ATTEMPT_1_SENT:
      return 'bg-blue-100 text-blue-800';
    case LeadAutomationStatus.ATTEMPT_2_SENT:
      return 'bg-blue-200 text-blue-900';
    case LeadAutomationStatus.ATTEMPT_3_SENT:
      return 'bg-indigo-100 text-indigo-800';
    case LeadAutomationStatus.BOOKED:
    case LeadStatus.MEETING_BOOKED:
      return 'bg-purple-100 text-purple-800';
    case LeadAutomationStatus.CANCELED:
      return 'bg-orange-100 text-orange-800';
    case LeadAutomationStatus.INACTIVE:
    case LeadStatus.LOST:
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getLeadStatusLabel = (status: LeadAutomationStatus | LeadStatus): string => {
  switch (status) {
    case LeadAutomationStatus.NEW:
      return 'New';
    case LeadAutomationStatus.ATTEMPT_1_SENT:
      return 'Attempt 1 Sent';
    case LeadAutomationStatus.ATTEMPT_2_SENT:
      return 'Attempt 2 Sent';
    case LeadAutomationStatus.ATTEMPT_3_SENT:
      return 'Attempt 3 Sent';
    case LeadAutomationStatus.BOOKED:
      return 'Booked';
    case LeadAutomationStatus.CANCELED:
      return 'Canceled';
    case LeadAutomationStatus.INACTIVE:
      return 'Inactive';
    case LeadAutomationStatus.ENGAGED:
    case LeadStatus.ENGAGED:
      return 'Engaged';
    case LeadAutomationStatus.PITCHED:
    case LeadStatus.PITCHED:
      return 'Pitched';
    case LeadAutomationStatus.WON:
    case LeadStatus.WON:
      return 'Won';
    default:
      return status as string;
  }
};

// Outreach result helpers
export const getOutreachResultColor = (result?: OutreachResult): string => {
  switch (result) {
    case OutreachResult.NO_REPLY:
      return 'bg-gray-100 text-gray-800';
    case OutreachResult.INTERESTED:
      return 'bg-green-100 text-green-800';
    case OutreachResult.NOT_INTERESTED:
      return 'bg-red-100 text-red-800';
    case OutreachResult.BOUNCED:
      return 'bg-orange-100 text-orange-800';
    case OutreachResult.BOOKED:
      return 'bg-purple-100 text-purple-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getOutreachResultLabel = (result?: OutreachResult): string => {
  switch (result) {
    case OutreachResult.NO_REPLY:
      return 'No Reply';
    case OutreachResult.INTERESTED:
      return 'Interested';
    case OutreachResult.NOT_INTERESTED:
      return 'Not Interested';
    case OutreachResult.BOUNCED:
      return 'Bounced';
    case OutreachResult.BOOKED:
      return 'Booked';
    default:
      return result || 'Pending';
  }
};

// Date formatting helper
export const formatDate = (date: Date | string | null | undefined): string => {
  if (!date) return 'N/A';

  const dateObj = date instanceof Date ? date : new Date(date);

  // Check if date is valid
  if (isNaN(dateObj.getTime())) {
    return 'Invalid Date';
  }

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(dateObj);
};

export const formatDateOnly = (date: Date | string | null | undefined): string => {
  if (!date) return 'N/A';

  const dateObj = date instanceof Date ? date : new Date(date);

  // Check if date is valid
  if (isNaN(dateObj.getTime())) {
    return 'Invalid Date';
  }

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(dateObj);
};